import { Injectable } from '@angular/core';
import { FC_CoolerCpuGabinete } from '../funcionesCompatibilidad/FC_CoolerCpuGabinete';
import { FC_GabineteCoolerFan } from '../funcionesCompatibilidad/FC_GabineteCoolerFan';
import { FC_GabineteFuente } from '../funcionesCompatibilidad/FC_GabineteFuente';
import { FC_MotherGabinete } from '../funcionesCompatibilidad/FC_MotherGabinete';
import { FC_VideoGabinete } from '../funcionesCompatibilidad/FC_VideoGabinete';
import { Incompatibilities } from '../Incompatibilities';
import { CoolerFan, Gabinete } from '../model';
import { DataArmado } from './DataArmado';
import { FuncionesArmadoBase } from './FuncionesArmadoBase';
import { FC_VideoFuente } from '../funcionesCompatibilidad/FC_VideoFuente';
import { FA_Fuente } from './FA_Fuente';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';

@Injectable({
  providedIn: 'root',
})
export class FA_Gabinete extends FuncionesArmadoBase<Gabinete> {
  constructor(
    private fc_motherGabinete: FC_MotherGabinete,
    private fc_gabineteFuente: FC_GabineteFuente,
    private fc_gabineteCoolerFan: FC_GabineteCoolerFan,
    private fc_coolerCpuGabinete: FC_CoolerCpuGabinete,
    private fc_videoGabinete: FC_VideoGabinete,
    private fc_videoFuente: FC_VideoFuente,
    private fa_Fuente: FA_Fuente,
  ) {
    super();
  }
  funciones = {
    coolerfan: (dataArmado: DataArmado, gabinete: Gabinete) => {
      let coolersfan = dataArmado.perifericos.filter(
        (periferico) => periferico instanceof CoolerFan,
      );
      if (!coolersfan.length) return [];
      return coolersfan.reduce((array: Incompatibilities[], coolerfan) => {
        array.push(...this.fc_gabineteCoolerFan.ejecutar(gabinete, coolerfan as CoolerFan));
        return array;
      }, []);
    },
    video: (dataArmado: DataArmado, gabinete: Gabinete) => {
      const videos = dataArmado.placasVideos;
      const fuente = dataArmado.fuentes[0] || null;
      if (!videos.length) return [];
      let respuesta: Incompatibilities[] = [];
      if (
        gabinete.$caracteristicas.id_fuente > 0 &&
        gabinete.$caracteristicas.kit == 1 &&
        !fuente
      ) {
        respuesta = videos.reduce((array: Incompatibilities[], video) => {
          array.push(
            ...this.fc_videoFuente.ejecutar(
              video,
              gabinete.$caracteristicas.$caracteristicas_fuente,
            ),
          );
          return array;
        }, []);
      }
      respuesta.push(
        ...videos.reduce((array: Incompatibilities[], video) => {
          array.push(...this.fc_videoGabinete.ejecutar(video, gabinete));
          return array;
        }, []),
      );
      return respuesta;
    },
    mother: (dataArmado: DataArmado, gabinete: Gabinete) => {
      let mother = dataArmado.mother[0];
      if (!mother) return [];
      return this.fc_motherGabinete.ejecutar(mother, gabinete);
    },
    fuente: (dataArmado: DataArmado, gabinete: Gabinete) => {
      let fuente = dataArmado.fuentes[0];
      if (!fuente) return [];
      return this.fc_gabineteFuente.ejecutar(gabinete, fuente);
    },
    coolercpu: (dataArmado: DataArmado, gabinete: Gabinete) => {
      let coolercpu = dataArmado.ccpu[0];
      if (!coolercpu) return [];
      return this.fc_coolerCpuGabinete.ejecutar(coolercpu, gabinete);
    },
    cantidadDiscos: (dataArmado: DataArmado, gabinete: Gabinete) => {
      let discos = dataArmado.discos.filter(
        (disco) => disco.$caracteristicas.dimension.toString() !== 'M2',
      );
      if (!discos.length) return [];
      let cantidadDiscosSeleccionados = discos.reduce(
        (result, discoActual) => {
          let dimensionDiscoActual = discoActual.$caracteristicas.dimension.toString();
          let cantidad: number = result[dimensionDiscoActual] + 1 || 1;
          result[dimensionDiscoActual] = cantidad;
          return result;
        },
        {} as { [x: string]: number },
      );

      const incompatibilidades: Array<Incompatibilities> = [];
      const equivalenciaDimension = {
        '2.5': 'unidades_2_5',
        '3.5': 'unidades_3_5',
        '3.25': 'unidades_3_25',
      };
      for (const dimension in cantidadDiscosSeleccionados) {
        if (
          cantidadDiscosSeleccionados[dimension] >
          gabinete.$caracteristicas[equivalenciaDimension[dimension]]
        ) {
          incompatibilidades.push({
            tipo: IncompatibilitiesType.ARMADO,
            incompatibility: `Slot de discos ${dimension} insuficiente`,
          });
        }
      }

      return incompatibilidades?.length ? incompatibilidades : [];
    },
    fuenteKit: (dataArmado: DataArmado, gabinete: Gabinete) => {
      let fuente = dataArmado?.fuentes[0];
      if (
        gabinete.$caracteristicas.id_fuente > 0 &&
        gabinete.$caracteristicas.kit == 1 &&
        !fuente
      ) {
        fuente = gabinete.$caracteristicas.$caracteristicas_fuente;
        const result: Incompatibilities[] = [
          this.fa_Fuente.funciones.capacidad(dataArmado, fuente),
          this.fa_Fuente.funciones.capacidadDiscosSATA(dataArmado, fuente),
        ]
          .flat()
          .filter((i) => i);
        return result || null;
      }
      return [];
    },
  };
}
